import { Col, Row } from "react-bootstrap";

export default function InputRadioSingle({
  label,
  opt1,
  opt2,
  name,
  state,
  onClick,
  register,
}) {
  function handleRadioClick(e) {
    onClick({ checked: e.target.checked, name: e.target.name });
  }
  return (
    <Row>
      <Col md={{ offset: 1, span: 4 }}>
        {label && <label htmlFor="registrationType">{label}:</label>}
      </Col>
      <Col md={6} className="d-flex align-items-center d-md-flex align-items-md-center">
        <span
          className={
            state[name] === false ? "switch-text-active" : "switch-text"
          }
        >
          {opt1}
        </span>
        <label className="switch">
          <input
            type="checkbox"
            id={name}
            name={name}
            onClick={handleRadioClick}
            {...register(name)}
          />
          <span className="slider round pick"></span>
        </label>
        <span className={state[name] ? "switch-text-active" : "switch-text"}>
          {opt2}
        </span>
      </Col>
    </Row>
  );
}
